import React from "react";
import { useSelector } from "types/store";
import Lineage from "components/Lineage/Lineage";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
const UseCaseLineage = ({ id }) => {
    const lineage = useSelector((state) => chatGPTReducer.getLineage(state, id));
    return React.createElement(Lineage, { lineage: lineage });
};
export default UseCaseLineage;
